import React from 'react';
import { Modal } from 'antd';
import cn from 'classnames';
import {
  useFieldController,
  useFormMethods,
} from '../../../../helpers/formManager';
import { fieldPathBuilders } from '../../shared/configs/acceptanceForm';
import Field from '../../shared/ui/Field';
import styles from './index.module.scss';

const {
  desk: {
    isCommonSchedules: createIsCommonSchedulesName,
    scheduleSettings: createScheduleSettingsName,
  },
} = fieldPathBuilders;

const SwitchSettingsForAllDays = ({
  deskIndex,
  disabled,
  size = 'default',
  className,
}) => {
  const { field } = useFieldController({
    name: createIsCommonSchedulesName(deskIndex),
    defaultValue: true,
  });

  const { unregister, getFieldState } = useFormMethods();

  const schedulesName = createScheduleSettingsName(deskIndex);

  const setValueAndUnregisterSchedules = (value) => {
    unregister(schedulesName);
    field.onChange(value);
  };

  const handleChange = (value) => {
    const { isDirty } = getFieldState(schedulesName);

    if (isDirty) {
      Modal.confirm({
        title: 'Заполненные ниже данные будут удалены. Продолжить?',
        centered: true,
        onCancel: () => {},
        onOk: () => {
          setValueAndUnregisterSchedules(value);
        },
      });
    } else {
      setValueAndUnregisterSchedules(value);
    }
  };

  return (
    <div className={cn(styles.root, className)}>
      <Field.Memoized
        type={Field.types.switch}
        checked={field.value}
        onChange={handleChange}
        disabled={disabled}
        size={size}
      />
      Один график на все дни
    </div>
  );
};

export default SwitchSettingsForAllDays;
